"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MyContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _FlexShareGroup = _interopRequireDefault(require("./../Business/FlexShareGroup"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*
 * @Author: syd
 * @Date: 2021-02-04 04:24:59
 * @Last Modified by: syd
 * @Last Modified time: 2021-04-07 17:46:13
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var MyContext = exports.MyContext = /*#__PURE__*/_react["default"].createContext({});
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    _a = props.shareList,
    shareList = _a === void 0 ? [] : _a,
    className = props.className,
    children = props.children,
    time = props.time,
    onClick = props.onClick,
    height = props.height,
    width = props.width,
    style = props.style,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "shareList", "className", "children", "time", "onClick", "height", "width", "style"]);
  //判断是否使用的样式类型 -pc or mobile
  // const [currentClass, setCurrentClass] = useState(true);
  // useEffect(() => {
  //     windowAddEventListener(setCurrentClass);
  // }, [])
  return time || shareList ? /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('flex-default-share-container', 'pc-flex-default-share-container', className)
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-share-container-ul-container'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-share-container-ul-container__time'
  }, time || 'time'), shareList.length ? /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", {
    className: 'flex-share-title-class'
  }, "Share\uFF1A"), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_FlexShareGroup["default"], __assign({}, shareList)))) : null)) : null;
});
Thumbnail.displayName = "TCIThumbnail";
var _default = exports["default"] = Thumbnail;